var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item && _vm.item.url)?_c('div',{staticClass:"org_body"},[_c('iframe',{attrs:{"id":"VkFrame","type":"text/html","src":_vm.item.url,"allowfullscreen":"","frameborder":"0"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }